import React, { useState, useEffect } from 'react';
import { api } from '../api';
import LimitsPage from './LimitsPage';

function formatBytes(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}

export default function SettingsPage({ onVisibilityChange }) {
  const [tab, setTab] = useState('interface');
  const [uiElements, setUIElements] = useState([]);
  const [uiVisibility, setUIVisibility] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [snapshots, setSnapshots] = useState([]);
  const [snapshotLoading, setSnapshotLoading] = useState(false);
  const [snapshotMsg, setSnapshotMsg] = useState('');
  const [backups, setBackups] = useState([]);
  const [backupLoading, setBackupLoading] = useState(false);
  const [backupMsg, setBackupMsg] = useState('');

  useEffect(() => {
    api.getUIElements().then(setUIElements).catch(() => {});
    api.getUIVisibility().then(setUIVisibility).catch(() => {});
  }, []);

  function setElementVisibility(elemId, visible) {
    setUIVisibility(prev => ({ ...prev, [elemId]: visible }));
  }

  function setAllVisibility(visible) {
    const next = {};
    uiElements.forEach(e => { next[e.id] = visible; });
    setUIVisibility(next);
  }

  async function save() {
    setSaving(true);
    try {
      await api.saveUIVisibility(uiVisibility);
      if (onVisibilityChange) onVisibilityChange(uiVisibility);
      setMsg('Настройки сохранены');
    } catch (err) {
      setMsg('Ошибка: ' + err.message);
    }
    setSaving(false);
  }

  const groups = {};
  uiElements.forEach(e => {
    if (!groups[e.group]) groups[e.group] = [];
    groups[e.group].push(e);
  });

  return (
    <div className="admin-page">
      <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '2px solid var(--border)' }}>
        <button
          onClick={() => setTab('interface')}
          style={{
            padding: '10px 24px', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer',
            border: 'none', borderBottom: tab === 'interface' ? '3px solid var(--accent)' : '3px solid transparent',
            background: 'transparent', color: tab === 'interface' ? 'var(--accent)' : 'var(--text2)',
          }}
        >Интерфейс</button>
        <button
          onClick={() => setTab('limits')}
          style={{
            padding: '10px 24px', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer',
            border: 'none', borderBottom: tab === 'limits' ? '3px solid var(--accent)' : '3px solid transparent',
            background: 'transparent', color: tab === 'limits' ? 'var(--accent)' : 'var(--text2)',
          }}
        >Лимиты</button>
        <button
          onClick={() => { setTab('backup'); api.listSnapshots().then(setSnapshots).catch(() => {}); }}
          style={{
            padding: '10px 24px', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer',
            border: 'none', borderBottom: tab === 'backup' ? '3px solid var(--accent)' : '3px solid transparent',
            background: 'transparent', color: tab === 'backup' ? 'var(--accent)' : 'var(--text2)',
          }}
        >Резерв системы</button>
        <button
          onClick={() => { setTab('dbbackup'); api.listBackups().then(setBackups).catch(() => {}); }}
          style={{
            padding: '10px 24px', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer',
            border: 'none', borderBottom: tab === 'dbbackup' ? '3px solid var(--accent)' : '3px solid transparent',
            background: 'transparent', color: tab === 'dbbackup' ? 'var(--accent)' : 'var(--text2)',
          }}
        >Бэкап БД</button>
      </div>

      {tab === 'interface' && (
        <>
          <h2>Настройки интерфейса</h2>

          <div style={{ marginBottom: 16, padding: 12, background: 'var(--bg3)', borderRadius: 6, fontSize: '0.85rem', color: 'var(--text2)' }}>
            Управляйте видимостью элементов интерфейса для всех пользователей системы. Скрытые элементы не будут отображаться в интерфейсе.
          </div>

          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <button className="btn-sm" onClick={() => setAllVisibility(true)}>Отобразить всё</button>
            <button className="btn-sm" onClick={() => setAllVisibility(false)}>Скрыть всё</button>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: 16 }}>
            {Object.entries(groups).map(([group, items]) => (
              <div key={group} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 16 }}>
                <h4 style={{ color: 'var(--accent)', marginBottom: 12, fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: 1 }}>{group}</h4>
                {items.map(e => {
                  const isVisible = uiVisibility[e.id] !== false;
                  return (
                    <div key={e.id} style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '10px 0', borderBottom: '1px solid var(--border)'
                    }}>
                      <span style={{ fontSize: '0.9rem', color: isVisible ? 'var(--text)' : 'var(--text2)' }}>{e.label}</span>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button
                          onClick={() => setElementVisibility(e.id, true)}
                          style={{
                            padding: '5px 14px', fontSize: '0.8rem', borderRadius: 6, cursor: 'pointer',
                            border: isVisible ? '2px solid var(--success)' : '1px solid var(--border)',
                            background: isVisible ? 'var(--success)' : 'var(--bg3)',
                            color: isVisible ? '#fff' : 'var(--text2)',
                            fontWeight: isVisible ? 700 : 400,
                            transition: 'all 0.15s',
                          }}
                        >
                          Отобразить
                        </button>
                        <button
                          onClick={() => setElementVisibility(e.id, false)}
                          style={{
                            padding: '5px 14px', fontSize: '0.8rem', borderRadius: 6, cursor: 'pointer',
                            border: !isVisible ? '2px solid var(--danger)' : '1px solid var(--border)',
                            background: !isVisible ? 'var(--danger)' : 'var(--bg3)',
                            color: !isVisible ? '#fff' : 'var(--text2)',
                            fontWeight: !isVisible ? 700 : 400,
                            transition: 'all 0.15s',
                          }}
                        >
                          Скрыть
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>

          <div style={{ marginTop: 24, display: 'flex', gap: 12, alignItems: 'center' }}>
            <button className="btn-add" onClick={save} disabled={saving}>
              {saving ? 'Сохранение...' : 'Сохранить настройки'}
            </button>
            {msg && <span style={{ color: msg.startsWith('Ош') ? 'var(--danger)' : 'var(--success)', fontSize: '0.9rem' }}>{msg}</span>}
          </div>
        </>
      )}

      {tab === 'limits' && <LimitsPage />}

      {tab === 'backup' && (
        <>
          <h2>Резерв системы</h2>
          <div style={{ marginBottom: 16, padding: 12, background: 'var(--bg3)', borderRadius: 6, fontSize: '0.85rem', color: 'var(--text2)' }}>
            Полный слепок всех данных системы: база данных, картинки, файлы чатов, загруженные файлы.
            Используйте перед обновлениями для защиты от потери данных.
          </div>

          <button
            className="btn-add"
            disabled={snapshotLoading}
            onClick={async () => {
              setSnapshotLoading(true);
              setSnapshotMsg('Создание слепка...');
              try {
                const result = await api.createSnapshot();
                setSnapshotMsg(`Слепок создан: ${result.name} (${formatBytes(result.size)})`);
                api.listSnapshots().then(setSnapshots).catch(() => {});
              } catch (err) {
                setSnapshotMsg('Ошибка: ' + err.message);
              }
              setSnapshotLoading(false);
            }}
          >
            {snapshotLoading ? 'Создание...' : 'Создать РЕЗЕРВ СИСТЕМЫ'}
          </button>
          {snapshotMsg && <div style={{ marginTop: 12, color: snapshotMsg.startsWith('Ош') ? 'var(--danger)' : 'var(--success)', fontSize: '0.9rem', fontWeight: 600 }}>{snapshotMsg}</div>}

          {snapshots.length > 0 && (
            <div style={{ marginTop: 24 }}>
              <h3>Существующие слепки</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 12 }}>
                {snapshots.map(s => (
                  <div key={s.name} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '12px 16px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8
                  }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{s.name}</div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>
                        {s.created ? new Date(s.created).toLocaleString('ru') : '—'} · {formatBytes(s.size)}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        className="btn-sm"
                        style={{ background: 'var(--warning)', color: '#000', fontWeight: 700 }}
                        onClick={async () => {
                          if (!window.confirm(`Восстановить систему из слепка ${s.name}? Текущие данные будут перезаписаны!`)) return;
                          setSnapshotLoading(true);
                          setSnapshotMsg('Восстановление...');
                          try {
                            const result = await api.restoreSnapshot(s.name);
                            setSnapshotMsg(result.message || 'Восстановлено');
                          } catch (err) {
                            setSnapshotMsg('Ошибка: ' + err.message);
                          }
                          setSnapshotLoading(false);
                        }}
                      >Восстановить</button>
                      <button
                        className="btn-sm"
                        style={{ background: 'var(--danger)', color: '#fff', fontWeight: 700 }}
                        onClick={async () => {
                          if (!window.confirm(`Удалить слепок ${s.name}? Это действие необратимо!`)) return;
                          try {
                            await api.deleteSnapshot(s.name);
                            setSnapshots(prev => prev.filter(x => x.name !== s.name));
                          } catch (err) {
                            setSnapshotMsg('Ошибка удаления: ' + err.message);
                          }
                        }}
                      >Удалить</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}

      {tab === 'dbbackup' && (
        <>
          <h2>Бэкап базы данных</h2>
          <div style={{ marginBottom: 16, padding: 12, background: 'var(--bg3)', borderRadius: 6, fontSize: '0.85rem', color: 'var(--text2)' }}>
            Быстрый бэкап только базы данных (без картинок и файлов). Занимает меньше места, создаётся мгновенно.
            Для полного резерва используйте вкладку "Резерв системы".
          </div>

          <button
            className="btn-add"
            disabled={backupLoading}
            onClick={async () => {
              setBackupLoading(true);
              setBackupMsg('Создание бэкапа...');
              try {
                const result = await api.createBackup();
                setBackupMsg(`Бэкап создан: ${result.name} (${formatBytes(result.size)})`);
                api.listBackups().then(setBackups).catch(() => {});
              } catch (err) {
                setBackupMsg('Ошибка: ' + err.message);
              }
              setBackupLoading(false);
            }}
          >
            {backupLoading ? 'Создание...' : 'Создать БЭКАП БД'}
          </button>
          {backupMsg && <div style={{ marginTop: 12, color: backupMsg.startsWith('Ош') ? 'var(--danger)' : 'var(--success)', fontSize: '0.9rem', fontWeight: 600 }}>{backupMsg}</div>}

          {backups.length > 0 && (
            <div style={{ marginTop: 24 }}>
              <h3>Существующие бэкапы</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 12 }}>
                {backups.map(b => (
                  <div key={b.name} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '12px 16px', background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8
                  }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: 8 }}>
                        {b.name}
                        {b.auto && <span style={{ fontSize: '0.7rem', background: 'var(--accent)', color: '#fff', padding: '2px 8px', borderRadius: 4, fontWeight: 700 }}>АВТО</span>}
                      </div>
                      <div style={{ fontSize: '0.8rem', color: 'var(--text2)' }}>
                        {b.created ? new Date(b.created).toLocaleString('ru') : '—'} · {formatBytes(b.size)}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        className="btn-sm"
                        style={{ background: 'var(--warning)', color: '#000', fontWeight: 700 }}
                        onClick={async () => {
                          if (!window.confirm(`Восстановить БД из бэкапа ${b.name}? Текущая база будет перезаписана!`)) return;
                          setBackupLoading(true);
                          setBackupMsg('Восстановление...');
                          try {
                            const result = await api.restoreBackup(b.name);
                            setBackupMsg(result.message || 'Восстановлено');
                          } catch (err) {
                            setBackupMsg('Ошибка: ' + err.message);
                          }
                          setBackupLoading(false);
                        }}
                      >Восстановить</button>
                      <button
                        className="btn-sm"
                        style={{ background: 'var(--danger)', color: '#fff', fontWeight: 700 }}
                        onClick={async () => {
                          if (!window.confirm(`Удалить бэкап ${b.name}? Это действие необратимо!`)) return;
                          try {
                            await api.deleteBackup(b.name);
                            setBackups(prev => prev.filter(x => x.name !== b.name));
                          } catch (err) {
                            setBackupMsg('Ошибка удаления: ' + err.message);
                          }
                        }}
                      >Удалить</button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
